import { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import CreateEventModal from "../../../../../components/modals/CreateEventModal";
import EventSuccessModal from "../../../../../components/modals/EventSuccessModal";
import { closeModal } from "../../../../../actions/event.action";

const ImageCard = ({ item, handleItemView }) => {
  return (
    <div onClick={() => handleItemView(item)} className="cursor-pointer">
      <div class="relative w-[500px]">
        <img src={item.imageUrl} alt="event" className="w-64 h-64 rounded-md" />
        <div class="absolute bottom-0 left-0 right-0 px-4 py-2 bg-gray-800 opacity-70">
          <div class="text-lg text-white font-bold single_line">
            {item.name}
          </div>
          <div class="text-sm text-gray-300 single_line">
            {item.description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function Event({ events }) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const cancelButtonRef = useRef(null);

  const {
    event: { modal },
  } = useSelector(({ eventReducer }) => ({
    event: eventReducer,
  }));

  const handleItemView = (item) => {
    history.push(`events/${item.id}`);
  };

  const handleViewMore = () => {
    history.push({
      pathname: "events",
    });
  };

  return (
    <div className="md:h-full py-10">
      <div className="flex flex-col items-center">
        <div className="text-2xl font-bold">Event</div>
        <div className="text-xl">Create, Join & View available Events</div>
      </div>
      <div className="flex mt-10">
        <div className=" p-5 bg-gra-100 rounded-md">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-6 mt-3">
            {/* <div className="flex flex-wrap gap-5"> */}
            {events.map((item, index) => {
              return (
                <ImageCard
                  item={item}
                  handleItemView={handleItemView}
                  key={index}
                />
              );
            })}
          </div>
        </div>
        <div className="w-4/12 p-10 flex flex-col justify-center">
          <div className="text-2xl font-bold">Create your own Event</div>
          <div className="text-xl">
            Create your own Event for others to view and join.
          </div>
          <div className="my-5">
            <button
              className="bg-green-800 py-2 px-5 rounded text-white"
              onClick={() => setOpen(true)}
            >
              Create
            </button>
            <button
              className="ml-2 md:ml-0 lg:ml-2 md:mt-1 bg-green-800 py-2 px-5 rounded text-white"
              onClick={() => handleViewMore()}
            >
              View More
            </button>
          </div>
        </div>
      </div>
      <CreateEventModal
        open={open}
        setOpen={setOpen}
        cancelButtonRef={cancelButtonRef}
      />
      <EventSuccessModal
        open={modal}
        setOpen={setSuccessModal}
        closeModal={closeModal}
      />
    </div>
  );
}
